/**
 * Shared encoding for the operator-based "stock" filter on
 * GET /outlet-items/report-items (e.g. stock=lt:1, stock=gt:10).
 *
 * Used by both the report page (pages/omset/CodeItems.vue) and its print
 * view (pages/receipt/StockBarang.vue) so the op:value convention only
 * needs to change in one place.
 */

/**
 * Whether a stock filter value should be sent at all.
 * @param {string|number|null|undefined} stockVal
 * @returns {boolean}
 */
export function hasStockFilter(stockVal) {
  return stockVal !== null && stockVal !== '' && stockVal !== undefined
}

/**
 * Append the "stock" param to a URLSearchParams instance if a filter value
 * is present; no-op otherwise.
 * @param {URLSearchParams} params
 * @param {string} stockOp - operator, e.g. 'gt', 'lt', 'eq'
 * @param {string|number|null|undefined} stockVal
 */
export function appendStockParam(params, stockOp, stockVal) {
  if (!hasStockFilter(stockVal)) {
    return
  }
  params.append('stock', `${stockOp}:${stockVal}`)
}
